import fetch from '../../lib/wrappedFetch'
import config from '../../config'

class ScheduledTasksService {
  createScheduledTask = ({ type, referenceType, referenceId, details, scheduledDate }) => {
    return fetch(config.config.endpointUrls.createScheduledTask(), {
      method: 'POST',
      body: { type, referenceType, referenceId, details, scheduledDate }
    })
  }
}

export default new ScheduledTasksService()



// WEBPACK FOOTER //
// ../src/services/scheduledTasksService/scheduledTasksService.js